import React from 'react';

interface WelcomeHeaderProps {
    userName: string;
    onClientClick: () => void;
    onCalendarClick: () => void;
}

const WelcomeHeader: React.FC<WelcomeHeaderProps> = ({ 
    userName, 
    onClientClick, 
    onCalendarClick 
}) => (
    <div className="bg-white border-l-4 border-green-600 rounded-lg shadow-lg p-6 mb-6">
        <h1 className="text-2xl font-bold mb-2 text-gray-800">¡Bienvenido, {userName}!</h1>
        <p className="text-gray-600">Este es tu panel de control personalizado para gestionar Bienesys.</p>
        <div className="mt-4 flex space-x-2">
            <button 
                onClick={onClientClick}
                className="bg-green-600 text-white hover:bg-green-700 px-4 py-2 rounded-md text-sm font-medium transition-colors"
            >
                Ver clientes
            </button>
            <button 
                onClick={onCalendarClick}
                className="bg-gray-100 text-gray-700 hover:bg-gray-200 px-4 py-2 rounded-md text-sm font-medium transition-colors"
            >
                Ir al calendario
            </button>
        </div>
    </div>
);

export default WelcomeHeader;